import { defineMessages } from 'react-intl'

export default defineMessages({
  noOptions: {
    id: 'containers.EmbeddedDealPage.components.Medias.noOptions',
    defaultMessage: 'No medias called',
  },
  searching: {
    id: 'containers.EmbeddedDealPage.components.Medias.searching',
    defaultMessage: 'Searching for',
  },
  medias: {
    id: 'containers.EmbeddedDealPage.components.Medias.medias',
    defaultMessage: 'Medias',
  },
})
